/* Keyaba -- carousel arrows for the category row. Progressive enhancement:
   if this never runs, the row still scrolls by swipe/trackpad. */
(function () {
  var ARROW = {
    prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 18l-6-6 6-6"/></svg>',
    next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18l6-6-6-6"/></svg>'
  };

  function enhance(row) {
    if (!row || row.dataset.keyabaScroller === 'on') return;
    if (!row.querySelector(':scope > .collection-card')) return;
    row.dataset.keyabaScroller = 'on';

    var wrap = row.parentElement;
    if (!wrap) return;
    wrap.classList.add('keyaba-scroller');

    function mkBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'keyaba-scroll-btn keyaba-scroll-btn--' + dir;
      b.innerHTML = ARROW[dir];
      b.setAttribute('aria-label', dir === 'prev' ? 'Scroll categories left' : 'Scroll categories right');
      b.addEventListener('click', function () {
        var card = row.querySelector(':scope > .collection-card');
        var step = card ? card.getBoundingClientRect().width + 18 : row.clientWidth * 0.8;
        row.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
      });
      return b;
    }

    var prev = mkBtn('prev');
    var next = mkBtn('next');
    wrap.appendChild(prev);
    wrap.appendChild(next);

    function sync() {
      var max = row.scrollWidth - row.clientWidth;
      var x = row.scrollLeft;
      prev.hidden = x <= 4;
      next.hidden = x >= max - 4 || max <= 4;
    }

    row.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(row);
    sync();
  }

  function run() {
    document.querySelectorAll('[id$="__categories"] .group-block-content').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();
